import {createActions} from 'reduxsauce';

export const actions = createActions(
  {
    setAuthToken: ['token'],
    setBearerToken: ['bearer'],
  },
  {prefix: 'auth'},
);
